import React, { useState } from "react";
import { authApi } from "../../api";
import { requestFcmPermissionAndToken } from "../../firebase";
import { useI18n } from "../../i18n";

export default function Login({ onSuccess, switchToSignup }) {
  const { t } = useI18n();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const doLogin = async () => {
    setError("");
    setLoading(true);
    try {
      let fcmToken = null;
      try {
        const vapid = process.env.REACT_APP_FCM_VAPID_KEY;
        if (vapid && 'Notification' in window) {
          fcmToken = await requestFcmPermissionAndToken(vapid);
        }
      } catch {}
      const res = await authApi.login({ username, password, fcmToken });
      if (res && res.needsVerification) {
        try {
          sessionStorage.setItem('tp_verify_phone', res.phone || '');
          sessionStorage.setItem('tp_verify_email', res.email || '');
          sessionStorage.setItem('tp_verify_name', res.name || '');
          sessionStorage.setItem('tp_verify_companyName', res.companyName || '');
          sessionStorage.setItem('tp_verify_companyAddress', res.companyAddress || '');
          // Do not store password
          sessionStorage.setItem('tp_verify_trigger', '1');
        } catch {}
        switchToSignup?.();
        return;
      }
      onSuccess?.();
    } catch (e) {
      setError(e?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white border border-green-100 rounded-2xl p-5 shadow-sm">
      <div className="grid gap-3">
        <input className="border rounded px-3 py-2" placeholder={t('login.username.placeholder')} value={username} onChange={(e) => setUsername(e.target.value)} />
        <div className="relative">
          <input
            className="border rounded px-3 py-2 w-full"
            type={showPassword ? "text" : "password"}
            placeholder={t('login.password.placeholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-green-600"
            onClick={() => setShowPassword((s) => !s)}
          >
            {showPassword ? t('login.password.hide') : t('login.password.show')}
          </button>
        </div>
      </div>
      {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
      <button className="mt-4 w-full bg-green-600 text-white py-2 rounded disabled:opacity-60" onClick={doLogin} disabled={loading}>
        {loading ? t('login.submit.loading') : t('login.submit.idle')}
      </button>
      <div className="flex items-center justify-between text-xs text-gray-500 mt-3">
        <button className="text-green-600 underline" onClick={switchToSignup}>{t('login.cta.create')}</button>
        <a 
          href="https://wa.me/919543268625?text=Reset Password" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-green-600 underline hover:text-green-700"
        >
          {t('login.forgot')}
        </a>
      </div>
    </div>
  );
}


